import PropTypes from 'prop-types'

import { getDisplayName, getUrlParam } from 'utils/mixpanel'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location } = props

    const trackers = {
      trackSelectFilter: ({ checkboxName }) =>
        mixpanel.track('Orders List_Status Quickfilter Applied', {
          'Checkbox Name': checkboxName,
          ...getUrlParam(location),
        }),
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
